module.exports = "https://cdn.thelire.com/ins/resource/lh_special_right@3x.e07603247e54c92b8e31f0e73cebe2cf.png";